<!-- Hamburger icon in the top left -->

<app-game-container>
  <div class="game" style="position: relative; height: 100%; width: 100%">
    <!-- Feedback bar -->
    @if (showFeedbackBar()) {
      <div
        class="pointer-events-auto absolute top-0 right-0 z-50 block h-[4%] w-max bg-black p-[0.5%] opacity-50 transition-opacity duration-300 ease-in-out select-none hover:opacity-100"
      >
        <!-- to the left, one rectangular buttons made with tailwind sayng "feedback" with a link to a feedback form, and a rectangular box with support email -->
        <div class="flex h-full items-center gap-[1ch] text-white" [ngStyle]="{ 'font-size': 'calc(0.6 * (1vw + 1vh))' }">
          <a
            class="pointer-events-auto rounded-sm bg-gray-600 text-nowrap text-white hover:bg-gray-400"
            href="https://forms.clickup.com/4767728/f/4hfzg-139872/BLNCXZFBVCBRRUTJFK"
            target="_blank"
            rel="noopener noreferrer"
          >
            Geef feedback
          </a>
          <span class="text-nowrap">
            of mail naar: <a class="underline" href="mailto:support@gametailors.com"> {{ 'support@gametailors.com' }}</a>
          </span>
        </div>
      </div>
    }

    <div style="position: absolute; width: 100%; height: 100%; display: grid; grid-template-areas: 'stack'">
      <!-- MAP -->
      @let map = gameService.map();
      @if (map) {
        <lp-map [map]="map" style="display: block; width: 100%; height: 100%; grid-area: stack" />
      }

      <!-- ACTIVITY -->
      @let activity = gameService.activity();
      <div class="activity-wrapper" style="grid-area: stack; width: 100%; height: 100%; isolation: isolate; pointer-events: none">
        @if (isCanvasActivity(activity)) {
          <lp-canvas-activity [activity]="activity" />
        } @else if (isIFrameActivity(activity)) {
          <lp-iframe-activity [activity]="activity" />
        } @else if (isClickActivity(activity)) {
          <lp-click-activity [activity]="activity" />
        } @else if (isDragAndDropActivity(activity)) {
          <lp-drag-and-drop-activity [activity]="activity" />
        } @else if (isWk8LevelActivity(activity)) {
          <wk8-level-activity [activity]="activity" />
        } @else if (isStoryActivity(activity)) {
          <lp-story-activity [storyActivity]="activity" />
        }
      </div>

      <!-- STORY -->
      @let story = gameService.story();
      @if (story) {
        <div class="story" style="position: absolute; width: 100%; height: 100%; grid-area: stack">
          <lp-story [story]="story" (finished)="clearStory()" />
        </div>
      }
    </div>

    @if (isInventoryEnabled() && gameService.inventory().length > 0) {
      <app-hud-icon-button
        style="display: block; position: absolute; top: 3em; right: 1em; width: 4em; height: 4em"
        [icon]="stylesService.SPRITE_ICON_INVENTORY()?.container"
        (click)="showInventory.set(!showInventory())"
        @modal
      />
    }

    @let notification = lpNotificationsService.notification();
    @let item = gameService.item();

    @if (showInventory() || notification !== undefined || item) {
      <div class="overlay" style="position: absolute; inset: 0; background: rgba(0, 0, 0, 0.75)" (click)="cancelOverlay()" @fade></div>
    }

    <!-- ITEM CONTENT -->
    @if (item) {
      <lp-inventory-item-modal
        [item]="item"
        style="position: absolute; width: 33%; top: 50%; left: 50%; translate: -50% -50%"
        (closed)="gameService.setItem(undefined)"
        @modal
      />
    }

    @if (notification) {
      <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); transform-origin: 0 0" @modal>
        <app-style-sheet-sprite
          [sprite]="stylesService.HUD_NOTIFICATION_PANEL()?.container"
          [text]="stylesService.HUD_NOTIFICATION_PANEL()?.text"
        >
          <div style="display: grid; min-width: 400px; gap: 0.5em; padding: 1em">
            @if (notification.title) {
              <lp-text [text]="notification.title" [animate]="true" style="justify-self: center; font-size: 2rem; font-weight: bold" />
            }
            @if (notification.message) {
              <lp-text [text]="notification.message" [animate]="true" />
            }
            <app-hud-button (click)="lpNotificationsService.next()" style="display: block; margin-top: 2em">Sluiten</app-hud-button>
          </div>
        </app-style-sheet-sprite>
      </div>
    }

    @if (showInventory()) {
      <lp-inventory
        [items]="gameService.inventory()"
        [enableDebug]="gameService.enableDebug()"
        [disableTabs]="true"
        style="display: block; position: absolute; top: 4rem; right: 4rem; transform-origin: top right"
        (removeItem)="gameService.removeInventoryItemAt($event)"
        @modal
      />
    }

    @if (gameService.enableDebug()) {
      <app-game-debug style="display: block; position: absolute; top: 0; left: 0; max-height: 25%; overflow-y: auto; font-size: 0.75em" />
    }
  </div>
</app-game-container>
